import React from 'react';
import moment from 'moment';

import BaseComponent from 'src/components/BaseComponent';
import { dateOfWeek, lang, remCss } from 'src/helpers';
import { TimePickerField, ToggleSwitch, MCButton, View, MCError } from 'src/components/basic';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import AlertManager from 'src/components/alert/AlertManager';
import LANG_CONST from 'src/helpers/lang/const';

export default class Schedule extends BaseComponent {
  state = {
    openTimeId: null
  };

  componentDidMount() {
    const { model } = this.props;
    model.baseSubscribe(this.subscription);
  }

  componentWillUnmount() {
    const { model } = this.props;
    model.unsubscribe(this.subscription);
  }

  delTime = (item, dateKey, index, times) => {
    const { model } = this.props;

    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          model.handleScheduleChange(item, dateKey, 'times', [
            ...times.slice(0, index),
            ...times.slice(index + 1)
          ]);
          actions.hide();
          actions.setLoading(false);
        }
      }
    });
  };

  addTime = (item, dateKey, times) => {
    const { model } = this.props;

    if (!times[times.length - 1].startTime || !times[times.length - 1].endTime) {
      AlertManager.popup(AlertManager.TYPES.WARN, {
        close: false,
        title: LANG_CONST.notice.select_some_dates,
        cancelButton: {
          label: LANG_CONST.buttons.ok,
          action: (actions) => actions.hide()
        }
      });
    } else {
      model.handleScheduleChange(item, dateKey, 'times', [
        ...times,
        { startTime: null, endTime: null }
      ]);
    }
  };

  render() {
    const { model } = this.props;
    const { openTimeId } = this.state;
    const { item } = this.props;
    const { schedule } = item;
    const createState = model.getApiState('update');
    const { loading, invalid: mainInvalid } = createState;
    let invalid = mainInvalid.schedule || {};
    return (
      <div className={'mc-flex-20-col mc-pb10'}>
        <div className={'mc-flex'}>
          <div className={'mc-flex-5-col mc-grow'}>
            <div className={'mc-value-518'}>{lang.t(LANG_CONST.text.set_standard_hours)}</div>
            <div className={'mc-label-418'}>{lang.t(LANG_CONST.text.config_standard_hours)}</div>
          </div>
        </div>
        {dateOfWeek.map((date, i) => {
          let dateKey = date.toLowerCase();
          const scheduleOfDate = schedule ? schedule[dateKey] : {};
          let { times, isOpen } = scheduleOfDate;
          if (!times) times = [{ startTime: null, endTime: null }];

          return (
            <div
              className={
                'mc-flex-col mc-radius-5 mc-p20 mc-b' + (openTimeId === dateKey ? '-primary' : '2')
              }
              key={i}
            >
              <div className={'mc-grow mc-flex-20 mc-pointer'}>
                <ToggleSwitch
                  checked={isOpen}
                  disabled={loading || model.isClinicDoctor()}
                  onChange={() => model.handleScheduleChange(item, dateKey, 'isOpen', !isOpen)}
                />
                <div
                  onClick={() => model.handleScheduleChange(item, dateKey, 'isOpen', !isOpen)}
                  className={'mc-value-418'}
                >
                  {lang.t(date)}
                </div>
                <div
                  className={'mc-grow mc-flex-col mc-flex-end'}
                  onClick={() =>
                    this.setState({ openTimeId: openTimeId === dateKey ? null : dateKey })
                  }
                >
                  <button
                    type={'button'}
                    className={
                      'mc-no-style-btn mc-rotate ' + (openTimeId === dateKey ? 'mc-rotate-180' : '')
                    }
                  >
                    <SVGIcon iconname={BASE_ICONS.DOWN} width={30} />
                  </button>
                </div>
              </div>
              {invalid[dateKey] && (
                <MCError
                  error={invalid[dateKey]}
                  mcTextProps={{ primary: true, style: { textAlign: 'center' } }}
                />
              )}
              <div
                className={
                  'mc-grow mc-wrap mc-flex-20-col mc-mr10 ' +
                  (openTimeId === dateKey ? '' : 'mc-hide')
                }
                style={{ zIndex: 3, maxWidth: remCss(700) }}
              >
                {times.map((time, index) =>
                  !time.startTime && !time.endTime && model.isClinicDoctor() ? null : (
                    <div className={'mc-flex-20'} key={index}>
                      <div className={'mc-grow'} style={{ minWidth: remCss(100) }}>
                        <TimePickerField
                          template={5}
                          width={'100%'}
                          disabled={model.isClinicDoctor()}
                          placeholder={lang.t(LANG_CONST.select_time)}
                          value={time.startTime && moment(time.startTime)}
                          onSelect={(value) =>
                            model.handleTimesScheduleChange(
                              item,
                              dateKey,
                              index,
                              'startTime',
                              value.valueOf()
                            )
                          }
                        />
                      </div>
                      <div className={'mc-value-418'}>{lang.t('To')}</div>
                      <div className={'mc-grow'} style={{ minWidth: remCss(100) }}>
                        <TimePickerField
                          template={5}
                          width={'100%'}
                          disabled={model.isClinicDoctor()}
                          placeholder={lang.t(LANG_CONST.select_time)}
                          value={time.endTime && moment(time.endTime)}
                          onSelect={(value) =>
                            model.handleTimesScheduleChange(
                              item,
                              dateKey,
                              index,
                              'endTime',
                              value.valueOf()
                            )
                          }
                        />
                      </div>
                      <View style={{ width: 50, justifyContent: 'center', alignItems: 'center' }}>
                        {!model.isClinicDoctor() &&
                          (index !== times.length - 1 ? (
                            <MCButton
                              iconname={BASE_ICONS.CLOSE}
                              secondary
                              light
                              small
                              radius
                              padding={5}
                              onClick={() => this.delTime(item, dateKey, index, times)}
                            />
                          ) : (
                            <MCButton
                              label={LANG_CONST.buttons.add}
                              primary
                              light
                              small
                              radius
                              onClick={() => this.addTime(item, dateKey, times)}
                            />
                          ))}
                      </View>
                    </div>
                  )
                )}
              </div>
            </div>
          );
        })}
        <div className='mc-grow mc-flex-col mc-flex-end'>
          <MCButton
            style={{ maxWidth: remCss(200) }}
            iconname={BASE_ICONS.DELETE}
            light
            radius
            small
            secondary
            type='button'
            label={LANG_CONST.buttons.delete}
            onClick={() => {
              AlertManager.popup(AlertManager.TYPES.WARN, {
                close: false,
                title: LANG_CONST.notice.delete_location,
                cancelButton: {
                  label: LANG_CONST.buttons.no,
                  action: (actions) => actions.hide()
                },
                actionButton: {
                  label: LANG_CONST.buttons.yes,
                  action: (actions) => {
                    actions.setLoading(true);
                    model.del(item, () => {
                      actions.hide();
                      actions.setLoading(false);
                    });
                  }
                }
              });
            }}
          />
        </div>
      </div>
    );
  }
}
